import React, { Component } from "react";
import PropTypes from "prop-types";
import { withRouter } from "react-router-dom";
import { Container, Row, Col, Button, Image } from "react-bootstrap";
import { connect } from "react-redux";
import PermissionHOC from "../PermissionHOC";
import { bindActionCreators } from "redux";
import {
  getBestPracticesListForHome,
  getBestPracticesCountForHome
} from "../../actions/userManagement.action";
import FileIcon from "../../assets/document-icon.svg";
import { CompassCalibrationOutlined } from "@material-ui/icons";
import { Search } from "../reusableComponent";
import { BEST_PRACTICES_PAGE_COUNT } from "../userManagement/helper";
import { isValidArray } from "../../helper";
import { get } from "lodash";
import { STATUS } from "../../constant";
import Pagination from "../Pagination";
import { PATHS } from "../../constant";
import { getGroupsByCategoryAction } from "../../actions/userManagement.action";
import NoDataFound from "../../component/NoDataFound";
import { LoaderPage } from "../../component/Loader";
import ReadMore from "../readMore";
import { dateFormat } from "../../helper";

const Params = {
  limit: BEST_PRACTICES_PAGE_COUNT,
  offset: 0,
  search: "",
  groupId: ""
};

export class BestPractices extends Component {
  constructor(props) {
    super(props);
    this.state = {
      bestPracticesList: [],
      isFile: true,
      paginationoffset: 0,
      bestPracticesPagination: { ...Params },
      isSearching: false,
      bestPracticesTotalCount: 0,
      showBubbleFilter: false,
      selectedFilter: null,
      makeSelectedNull: false,
      isAllDataLoaded: false,
      offset: 0,
      limit: BEST_PRACTICES_PAGE_COUNT,
      showFullDescriptions: {}
    };
  }

  componentDidMount() {
    const {
      getBestPracticesListDispatch,
      getBestPracticesCountDispatch,
      getGroupsByCategoryActionDispatch
    } = this.props;
    const { offset, limit } = this.state;
    getBestPracticesListDispatch(undefined, {
      groupId: "",
      offset: offset,
      limit: limit,
      search: ""
    })
      .then(response => {
        // check the response and dispatch a different action or show an error message if necessary
        this.setState({
          bestPracticesList: response.data
        });
      })
      .catch(error => {
        // show an error message to the user
        console.log("error", error);
      });

    getBestPracticesCountDispatch(
      undefined,
      this.state.bestPracticesPagination
    ).then(res => {
      this.setState({
        bestPracticesTotalCount: res.data
      });
    });

    getGroupsByCategoryActionDispatch(undefined, {
      category: ["CENTRAL", "PMG"]
    }).then(res => {
      this.setState({
        groups: res.data
      });
    });
  }

  toggleDescription = index => {
    const { showFullDescriptions } = this.state;
    this.setState({
      showFullDescriptions: {
        ...showFullDescriptions,
        [index]: !showFullDescriptions[index]
      }
    });
  };

  truncateDescription = description => {
    const words = description.split(" ");
    if (words.length <= 10) {
      return description;
    }
    return words.slice(0, 10).join(" ") + "...";
  };

  onSearch = (e, values) => {
    const { name, value } = values;
    this.setState(prevState => ({
      paginationoffset: 0,
      bestPracticesPagination: {
        ...prevState.bestPracticesPagination,
        offset: 0,
        [name]: value
      }
    }));
  };

  createFileTemplate = item => {
    const { isFile } = this.state;
    if (item.files.length === 0) {
      return null;
    } else if (item.files.length > 0) {
      return (
        <>
          <div className="d-flex best-practices-file-view">
            <Image src={FileIcon} className="mt-3" />
            {item.files.map((file, index) => {
              return (
                <React.Fragment key={file.s3Url}>
                  <a
                    className="best-practice-file-name ml-2"
                    target="_blank"
                    href={file.s3Url}
                  >
                    {file.name}
                  </a>
                  <div className="best-practice-file">
                    {index < item.files.length - 1 && ", "}
                  </div>
                </React.Fragment>
              );
            })}
          </div>
        </>
      );
    }
  };

  onPageChange = page => {
    const { getBestPracticesListDispatch } = this.props;
    this.setState(
      prevState => ({
        paginationoffset: page.selected || 0,
        bestPracticesPagination: {
          ...prevState.bestPracticesPagination,
          offset: page.selected || 0,
          limit: BEST_PRACTICES_PAGE_COUNT
        }
      }),
      () => {
        getBestPracticesListDispatch(
          undefined,
          this.state.bestPracticesPagination
        ).then(res => {
          this.setState({
            bestPracticesList: res.data
          });
        });
      }
    );
  };

  onLoadMore = async () => {
    const { isAllDataLoaded, offset, limit } = this.state;
    const { getBestPracticesListDispatch } = this.props;
    const totalLimit = limit + BEST_PRACTICES_PAGE_COUNT;
    if (isAllDataLoaded) {
      return;
    }
    this.setState(
      {
        isAllDataLoaded: true,
        limit: totalLimit
      },
      () => {
        getBestPracticesListDispatch(undefined, {
          groupId: "",
          offset: offset,
          limit: totalLimit,
          search: ""
        }).then(response => {
          this.setState({
            bestPracticesList: response.data,
            isAllDataLoaded: false
          });
        });
      }
    );
  };

  onSearch = (e, values) => {
    const { name, value } = values;
    this.setState(prevState => ({
      paginationoffset: 0,
      bestPracticesPagination: {
        ...prevState.bestPracticesPagination,
        offset: 0,
        [name]: value
      }
    }));
  };

  callAfterDebounce = () => {
    const {
      getBestPracticesListDispatch,
      getBestPracticesCountDispatch
    } = this.props;
    this.setState(
      {
        isSearching: true
      },
      async () => {
        await getBestPracticesListDispatch(
          undefined,
          this.state.bestPracticesPagination
        ).then(res => {
          this.setState({
            bestPracticesList: res.data
          });
        });
        this.setState({
          isSearching: false
        });

        getBestPracticesCountDispatch(
          undefined,
          this.state.bestPracticesPagination
        ).then(res => {
          this.setState({
            bestPracticesTotalCount: res.data
          });
        });
      }
    );
  };

  getFilterId = (id, elem) => {
    const {
      getBestPracticesListDispatch,
      getBestPracticesCountDispatch
    } = this.props;

    if (id === 0) {
      this.removeFilter();
    } else {
      this.setState(
        prevState => ({
          paginationoffset: 0,
          showBubbleFilter: true,
          selectedFilter: elem,
          makeSelectedNull: false,
          bestPracticesPagination: {
            ...prevState.bestPracticesPagination,
            offset: 0,
            groupId: id
          }
        }),
        () => {
          getBestPracticesCountDispatch(
            undefined,
            this.state.bestPracticesPagination
          ).then(res => {
            this.setState({
              bestPracticesTotalCount: res.data
            });
          });

          getBestPracticesListDispatch(
            undefined,
            this.state.bestPracticesPagination
          ).then(res => {
            this.setState({
              bestPracticesList: res.data
            });
          });
        }
      );
    }
  };

  removeFilter = () => {
    const {
      getBestPracticesListDispatch,
      getBestPracticesCountDispatch
    } = this.props;
    const { limit, offset } = this.state;

    this.setState(
      prevState => ({
        paginationoffset: 0,
        showBubbleFilter: false,
        selectedFilter: null,
        makeSelectedNull: true,
        bestPracticesPagination: {
          ...prevState.bestPracticesPagination,
          offset: 0,
          groupId: ""
        }
      }),
      () => {
        getBestPracticesListDispatch(undefined, {
          groupId: "",
          offset: offset,
          limit: limit,
          search: ""
        }).then(res => {
          this.setState({
            bestPracticesList: res.data
          });
        });

        getBestPracticesCountDispatch(undefined, {
          groupId: "",
          offset: offset,
          limit: limit,
          search: ""
        }).then(res => {
          this.setState({
            bestPracticesTotalCount: res.data
          });
        });
      }
    );
  };

  render() {
    const { onSearch, callAfterDebounce } = this;
    const {
      bestPracticesList,
      bestPracticesPagination,
      isSearching,
      bestPracticesTotalCount,
      showBubbleFilter,
      selectedFilter,
      makeSelectedNull,
      paginationoffset,
      groups,
      isAllDataLoaded,
      showFullDescription
    } = this.state;
    const { isBestPracticesLoading } = this.props;
    let url = window.location.pathname;
    // if (url === PATHS.BEST_PRACTICES) {
    //   const header = document.getElementById("root");
    //   header.style.marginTop = "5%";
    // }

    //Filter list based on category
    let filterList = [{ id: 0, name: "Reset All" }];
    if (isValidArray(groups)) {
      groups.forEach(elem => {
        filterList.push(elem);
      });
    }
    return (
      <React.Fragment>
        <LoaderPage loading={isAllDataLoaded} />
        <div className="content no-sidebar listpage-wrapper best-practice-page">
          <div className="best-practices">
            <div className="d-flex justify-content-between">
              <div className="best-practices-title">Best Practices</div>
              <div className="issue-list-exposed-filters search-in-user pb-2 pr-4">
                <div className="issue-list-filter-right">
                  <div className="filters-sections">
                    <Search
                      placeholder="Search"
                      keyName="search"
                      onChange={onSearch}
                      value={bestPracticesPagination.search}
                      isLoading={isSearching}
                      callAfterDebounce={callAfterDebounce}
                      isSearchingBestPractice={true}
                      filterList={filterList}
                      getFilterId={this.getFilterId}
                      makeSelectedNull={makeSelectedNull}
                    />
                  </div>
                </div>
              </div>
            </div>
            {showBubbleFilter ? (
              <div className="applied-filter-list pt-3 mb-0">
                <div className="applied-filter mb-0">
                  {selectedFilter && selectedFilter.name}
                  <span
                    className="close"
                    onClick={e => {
                      this.removeFilter();
                    }}
                  >
                    X
                  </span>
                </div>
              </div>
            ) : null}
            <div className="best-practices-cards flex flex-column flex-md-row">
              {bestPracticesList.length > 0 ? (
                bestPracticesList.map((item, index) => (
                  <Container
                    fluid
                    className="best-practices-card ml-0 col col-md-4"
                  >
                    <Row
                      className={` ${
                        !this.state.showFullDescriptions[index]
                          ? "best-practice-read-more"
                          : ""
                      } best-practice-row`}
                    >
                      <Col className="agenda agenda-col-1 best-practices-card-data">
                        <div className="best-practice-cards-container">
                          <div>
                            <div className="agenda-details">
                              <div className="agenda-list-title">
                                <span className="best-practice-id">
                                  {item.organization}
                                </span>
                              </div>
                            </div>
                            <div className="best-practice-info">
                              <span>
                                <b>{item.title}</b>
                                <p className="best-practices-description">
                                  {this.state.showFullDescriptions[index]
                                    ? item.description
                                    : this.truncateDescription(
                                        item.description
                                      )}
                                  {this.truncateDescription(
                                    item.description
                                  ) !== item.description && (
                                    <a
                                      className="read-more-icon"
                                      onClick={() =>
                                        this.toggleDescription(index)
                                      }
                                    >
                                      {this.state.showFullDescriptions[
                                        index
                                      ] ? (
                                        <b> Read Less</b>
                                      ) : (
                                        <b> Read More</b>
                                      )}
                                    </a>
                                  )}
                                </p>
                              </span>
                            </div>
                          </div>
                          <div>
                            <div class={"best-practice-addedon-container"}>
                              <div
                                className={`best-practices-created-on d-flex ${
                                  item.files.length === 0
                                    ? "justify-content-end"
                                    : "justify-content-between"
                                }`}
                              >
                                {this.createFileTemplate(item)}
                                <div className="added-on">
                                  Added on{" "}
                                  <span className="ml-1">
                                    {dateFormat(item.createdDate)}
                                  </span>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </Col>
                    </Row>
                  </Container>
                ))
              ) : (
                <NoDataFound /> //No data found component
              )}
            </div>
          </div>
        </div>
        {bestPracticesTotalCount - bestPracticesList.length ? (
          <div className="best-practices-pagination-wrapper mt-5 justify-content-center pb-5">
            <div class="pagination pagination-in-user-listing">
              <Button className="btn btn-primary" onClick={this.onLoadMore}>
                Load More
              </Button>
            </div>
          </div>
        ) : null}
      </React.Fragment>
    );
  }
}

function mapStateToProps(state) {
  return {
    isBestPracticesLoading: state.userManagementReducer.isBestPracticesLoading,
    bestPracticesList: state.userManagementReducer.bestPracticesList,
    groups: state.userManagementReducer.groups
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      getBestPracticesListDispatch: getBestPracticesListForHome,
      getBestPracticesCountDispatch: getBestPracticesCountForHome,
      getGroupsByCategoryActionDispatch: getGroupsByCategoryAction
    },
    dispatch
  );
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(BestPractices);
